import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { EcryptServiceService } from 'src/app/services/ecrypt-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-ordersuccess',
  templateUrl: './ordersuccess.component.html',
  styleUrls: ['./ordersuccess.component.scss']
})
export class OrdersuccessComponent implements OnInit {



  @Input() item: any;
  @Input() img: any;
  @Input() data: any;

  bigImage: any;

  public serverPathLogo = environment.commonImageApi + '/home/';

  public serverPath = environment.ImageAPI;

  public serverPath1 = environment.commonImageApiNew + 'medicineimages/'

  public serverPath7 = environment.commonImageApi + "catalog/product";

  orderId: any;
  
  orderItem: any;

  constructor(private commonService: CommonService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ecryptService: EcryptServiceService,
  ) {

    this.bigImage = environment.ImageAPI1;

  }
  ngOnInit(): void {

    let value = localStorage.getItem("orderItem")

    if (value == undefined || value == null) {

      this.router.navigate(['/']);

    } else {

      value = this.ecryptService.decryptionAES(value);

      this.orderId = JSON.parse(value);

      this.orderItem = this.orderId['salesFlatOrderItem']

      console.log(this.orderId);


    }



  }


  // goToCategories(id: any) {
  //   if(id>0){
  //     this.commonService.goToCategory(1, parseInt(id));
  //   }

  // }


  link(url: any) {

    this.commonService.goToLink(url)
  }

  openInNewWindow(url: string) {
    if (url) {
      const fullURL = this.prependProtocol(url);
      this.commonService.goToLink(url)
    }
  }

  prependProtocol(url: string): string {
    if (!url.includes('http://') && !url.includes('https://')) {
      return 'https://' + url;
    }
    return url;
  }

  navigateToHome() {
    this.router.navigate(['/'])
  }

  order() {

    this.router.navigate([`/order/${this.orderId.entityId}`])
  }

}
